/*
Copyright 2026 Dexnet / iON.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

/*
 * iON (decision 87, BUGS 193): "Call back" on the end screen. The ring is
 * sent only by the first one in a call; right after the end of a call of
 * two the other side is often still in it for a few seconds (its own end
 * screen), so joining at once joins the old call, and it ends again when they
 * leave, without ringing. So call back once the call is empty — or after a
 * while, when someone really stays in it.
 */

import {
  MatrixRTCSessionEvent,
  type MatrixRTCSession,
} from "matrix-js-sdk/lib/matrixrtc";

export const ION_CALL_BACK_WAIT_MS = 10_000;

/** Resolves when nobody is in the call any more, or after `timeoutMs`. */
export async function whenCallEmpty(
  session: Pick<MatrixRTCSession, "memberships" | "on" | "off">,
  timeoutMs = ION_CALL_BACK_WAIT_MS,
): Promise<void> {
  if (session.memberships.length === 0) return;
  return new Promise((resolve) => {
    const done = (): void => {
      clearTimeout(timeout);
      session.off(MatrixRTCSessionEvent.MembershipsChanged, onChange);
      resolve();
    };
    const onChange = (): void => {
      if (session.memberships.length === 0) done();
    };
    const timeout = setTimeout(done, timeoutMs);
    session.on(MatrixRTCSessionEvent.MembershipsChanged, onChange);
  });
}
